import { render, staticRenderFns } from "./OtherSupplierServices.vue?vue&type=template&id=adca2142&scoped=true&"
import script from "./OtherSupplierServices.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adca2142",
  null
  
)

export default component.exports